import { createApp } from 'vue'
import App from './App.vue'
import router from "@/router";
import store from '@/store'
import { Icon } from '@iconify/vue';
// контейнер модального окна
import VModal from "@/components/Admin/UI/VModal";
// карточка
import VCard from "@/components/Admin/UI/VCard";
// ссылка для вызова модального окна
import VIconLink from "@/components/Admin/UI/VIconLink";
// окно подтверждения
import VConfirmModal from "@/components/Forms/VConfirmModal";
// маска
// https://vuejs-tips.github.io/vue-the-mask/
// npm i -S vue-the-mask
import VueTheMask from 'vue-the-mask'
// стили
import './vendor.css'

const app = createApp(App)
    app.use(router)
    app.use(store)
    app.use(VueTheMask)
    // глобальные компоненты
    app.component('v-icon', Icon)
    app.component('v-modal', VModal)
    app.component('v-card', VCard)
    app.component('v-icon-link', VIconLink)
    app.component('v-confirm', VConfirmModal)
    app.mount('#app')